import { URLS } from 'modules/axios'
import useApi from 'composables/useApi'

export function respostasService() {
  const api = () => useApi()

  /** @param {import('../types/respostas').RespostaPost} data */
  function postRespostaButton(data) {
    return api().mutation(
      `${URLS.item_respostas_button}`,
      'POST',
      data
    )
  }
  /** @param {import('../types/respostas').RespostaPost} data */
  function postRespostaLivre(data) {
    return api().mutation(
      `${URLS.item_respostas_livre}`,
      'POST',
      data
    )
  }

  /** @param {import('../types/respostas').RespostaPost} data */
  function deleteResposta(id) {
    return api().mutation(`${URLS.item_respostas}${id}/`, 'DELETE')
  }

  return {
    postRespostaButton,
    postRespostaLivre,
    deleteResposta,
  }
}
